import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '@iconify/react';

const MESSAGES = [
  'Connecting with Brainiacs AI Engine…',
  'Researching your target accounts…',
  'Analyzing company profiles…',
  'Scoring lead-ICP fit…',
  'Building intelligence briefings…',
  'Generating outreach strategies…',
  'Crafting hyper-personalized messages…',
  'Validating email channels…',
  'Preparing your campaign…',
  'Almost ready…',
];

interface ProcessingCarouselProps {
  className?: string;
}

/**
 * Carousel of processing messages with a fade-in/out transition. Cycles
 * through the message list at 2.4s intervals, showing one at a time.
 */
export const ProcessingCarousel: React.FC<ProcessingCarouselProps> = ({ className = '' }) => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const timer = useRef<ReturnType<typeof setInterval> | undefined>(undefined);

  useEffect(() => {
    timer.current = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % MESSAGES.length);
        setFade(true);
      }, 200);
    }, 2400);
    return () => clearInterval(timer.current);
  }, []);

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <Icon icon="solar:magic-wand-3-bold-duotone" className="h-3.5 w-3.5 animate-spin text-[#5260FF]" aria-hidden="true" />
      <span
        className="text-[10px] font-black uppercase tracking-[0.16em] text-[#5260FF] transition-opacity duration-200"
        style={{ opacity: fade ? 1 : 0 }}
      >
        {MESSAGES[index]}
      </span>
    </div>
  );
};